import React from "react";
import Button from "../../../form/Button";
import { useMutation } from "@tanstack/react-query";
import { pendingBookingComplete } from "../../../../services/orderService";
import StripePayment from "../StripePayment";
import { useLocation } from "react-router-dom";

const PayRemaining = ({ orderData = {} }) => {
  const location = useLocation();
  const {
    mutate: payRemainingHandler,
    isPending: payRemainingIsPending,
    data: payRemainingData,
  } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        id: orderData?._id,
        orderItemsData: orderData?.orderItemData?.map((orderItem) => ({
          orderItemId: orderItem?._id,
        })),
      };
      const res = await pendingBookingComplete(payload);
      if (res?.status === 200) {
        if (res?.data?.approvalUrl) {
          window.open(res?.data?.approvalUrl, "_blank");
        }
      }
      return res;
    },
  });

  if (orderData?.status?.info !== "confirmed") {
    return <></>;
  }

  return (
    <div className="w-full pt-5 flex items-center justify-center">
      {orderData?.fullPaid === "no" &&
        !(
          payRemainingData?.data?.clientSecret &&
          payRemainingData?.data?.merchantId
        ) && (
          <Button
            buttonLabel={"pay remaining"}
            buttonFunction={payRemainingHandler}
            {...(payRemainingIsPending && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
        )}
      {payRemainingData?.data?.clientSecret &&
        payRemainingData?.data?.merchantId && (
          <StripePayment
            {...payRemainingData?.data}
            callbackUrl={`${window.location.origin}${location?.pathname}${location?.search}`}
            getResponse={(res) => {
              console.log(res);
            }}
          />
        )}
    </div>
  );
};

export default PayRemaining;
